import ProdDeliveriesHeader from "./Header";
import "./index.css";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import ProdDeliveriesContents from "./Transport";
import { ShowHide } from "../components/ShowHideProduct";
import FlowNumbersBox from "../components/FlowNumbersBox";

const ProdDeliveriesComponent = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="prod-transport-container" id="prod-deliveries-id">
      <ProdDeliveriesHeader productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
        <FlowNumbersBox isNormal={true} number={"Flow 13"} color={"#193666"} />
      </div>
      {show && <ProdDeliveriesContents productId={productId} />}
    </div>
  );
};

export default ProdDeliveriesComponent;
